import AccountBanner from "components/AccountBanner";
import Signup from "components/Signup";
import React, { useContext } from "react";
import AuthContext from "components/context/AuthContext";
import CreateUser from "components/CreateUser";

const Register = () => {
  const { isEmail, isDetails } = useContext(AuthContext);

  return (
    <div className=" flex fixed w-[100vw] justify-between">
      {isEmail && <Signup />}
      {isDetails && <CreateUser />}
      <AccountBanner />
    </div>
  );
};

export default Register;
